console.log(process.env.VUE_APP_EXCLUDE_TESTING_LINK)
export default {
    BASE_API: process.env.VUE_APP_BASE_API || '/',
    ILLUMINATE_CLIENT_ID: process.env.VUE_APP_ILLUMINATE_CLIENT_ID,
    USE_ILLUMINATE_LOGIN: process.env.VUE_APP_USE_ILLUMINATE_LOGIN.toLowerCase() === "true",
    CONSOLE_URL: process.env.VUE_APP_CONSOLE_URL,
    EXCLUDE_TESTING_LINK: (process.env.VUE_APP_EXCLUDE_TESTING_LINK == undefined) ? [] : process.env.VUE_APP_EXCLUDE_TESTING_LINK.split(',')
}